import { render, staticRenderFns } from "./DrawSR.vue?vue&type=template&id=3a94625d&"
import script from "./DrawSR.vue?vue&type=script&lang=js&"
export * from "./DrawSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports